const detailDataDefault = {
  base: {
    label: '基础信息',
    tableData: {
      title: [
        {
          prop: 'plateNumber',
          label: '车牌号码',
        },
        {
          prop: 'vehicleClassName',
          label: '车辆种类',
        },
        {
          prop: 'licenceTypeName',
          label: '牌照类型',
        },
      ],
      data: {},
      approveData: {},
    },
  },
  fleet: {
    label: '发起请求的车队',
    tableData: {
      title: [
        {
          prop: 'tenantName',
          label: '车队名称',
        },
        {
          prop: 'linkPhone',
          label: '车队电话',
        },
        {
          prop: 'applyVehicleClassName',
          label: '申请类型',
        },
      ],
      data: {},
      approveData: {},
    },
  },
  applyInfo: {
    label: '',
    tableData: {
      title: [],
    },
  },
  approve: {
    label: '审核结果',
    tableData: {
      title: [
        {
          prop: 'stateName',
          label: '审核状态',
        },
        {
          prop: 'auditDate',
          label: '审核时间',
        },
        {
          prop: 'auditRemark',
          label: '审核意见',
        },
      ],
      data: {},
      approveData: {},
    },
  },
};

export default detailDataDefault;
